import React from 'react'
import '../../App.css'
import Carousel from '../Carousel';
import Steps from '../Steps';
import Stats from '../Stats';
import Calculator from '../Calculator';
import Coverage from '../Coverage';
import Partners from '../Partners';
function Home() {
  return (
    <>
        <Carousel/>
        <Steps/>
        <Stats/>
        <Calculator/>
        <Coverage/>
        <Partners/>
    </>
  )
}

export default Home;